<script>
    import {API_URL} from "../../env";
    import Error from "../placeholders/Error.svelte";
    import ContentLoading from "../placeholders/ContentLoading.svelte";

    window.scrollTo(0, 0);

    let data = fetchData()

    async function fetchData() {
        const res = await fetch(API_URL+'/pages/gdpr');
        return await res.text()
    }

    function changeCookies() {
        let revision = JSON.parse(getCookie('cc_cookie')).revision

        cc.showSettings(revision + 1);
    }
</script>

<div class="container">
    <section class="info-page mt-lg-5 mb-lg-5">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-md-8 col-lg-9">
                        <h2 class="section-title">Ochrana osobných údajov</h2>
                    </div>
                    <div class="col-12 col-md-4 col-lg-3 mt-2 mb-4 mt-md-0 mb-md-0 d-flex justify-content-end">
                        <a class="info-button align-self-center align-content-center w-100" id="open-cookie-settings" on:click={changeCookies}>Zmeniť nastavenia cookies</a>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="info-content">
                    {#await data}
                        <ContentLoading/>
                    {:then data}
                        {@html data}
                    {:catch error}
                        <Error/>
                    {/await}
                </div>
            </div>
        </div>
    </section>
</div>